import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
    apiKey: "AIzaSyDevJaRIseikzj0d4Nh5WpouTugGoIRICA",
    authDomain: "pivot3mvp.firebaseapp.com",
    databaseURL: "https://pivot3mvp.firebaseio.com",
    projectId: "pivot3mvp",
    storageBucket: "",
    messagingSenderId: "510154866587",
    appId: "1:510154866587:web:6fb2cc1d0f25cd42"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase

// firebase collections
const usersCollection = db.collection('users')

export {
    db,
    auth,
    currentUser,
    usersCollection,
}